import type {
  ShareBetData,
  QuickbetShare,
  TicketShare,
  BetSlipShare,
} from '@core/Areas/ShareBet/types'

export function isTicketShareData(share: ShareBetData): share is TicketShare {
  return share.contextType === 'ticket'
}

export function isQuickbetShareData(share: ShareBetData): share is QuickbetShare {
  return share.contextType === 'quickbet'
}

export function isBetSlipShareData(share: ShareBetData): share is BetSlipShare {
  return share.contextType === 'betslip'
}
